import {
  all,
  call,
  put,
  takeEvery,
  takeLatest,
  takeLeading,
} from 'redux-saga/effects';
import {
  getAgreementDebt,
  getAgreementPortionDebt,
  getBilletDeal,
  getLinhaDigitavelDealBillet,
} from './actions';
import api from '../../services/api';

function* getAgreementDebtSaga() {
  try {
    const agreements = yield call(api.getAgreementDetails);
    yield put(getAgreementDebt.success(agreements));
  } catch {
    yield put(getAgreementDebt.failure('Falha ao buscar propostas.'));
  }
}

function* getAgreementPortionDebtSaga(
  action: ReturnType<typeof getAgreementPortionDebt.request>
) {
  try {
    const portions = yield call(api.getAgreementPortionDetails, {
      dealId: action.payload.dealId,
      databaseId: action.payload.databaseId,
    });
    yield put(getAgreementPortionDebt.success(portions));
  } catch {
    yield put(getAgreementDebt.failure('Falha ao buscar propostas.'));
  }
}

function* getBilletDealSaga(action: ReturnType<typeof getBilletDeal.request>) {
  // PDF e Imprimir Boleto
  try {
    const billet = yield call(api.getBilletDeal, {
      dealId: action.payload.dealId,
      portionId: action.payload.portionId,
      databaseId: action.payload.databaseId,
    });
    yield put(getBilletDeal.success(billet));

    if (billet && billet.linhaDigitavel)
      action.payload.callBack({ ...billet, doc: action.payload.type });
  } catch {
    yield put(getBilletDeal.failure('Falha ao obter boleto.'));
  }
}

function* getLinhaDigitavelDealBilletSaga(
  action: ReturnType<typeof getLinhaDigitavelDealBillet.request>
) {
  // Linha digitavel, sms, wpp e e-mail
  try {
    const billet = yield call(api.getLinhaDigitavelDealBillet, {
      databaseId: action.payload.databaseId,
      options: {
        dealId: action.payload.dealId,
        portionId: action.payload.portionId,
        sendType: action.payload.sendType as GQL.SendType,
        creditorId: action.payload.creditorId,
      },
    });
    yield put(getLinhaDigitavelDealBillet.success(billet));

    if (billet && billet.linhaDigitavel)
      action.payload.callBack(action.payload.sendType as GQL.SendType, billet);
  } catch (error) {
    if (!error.toString().includes('Confirme seu telefone.'))
      yield put(getLinhaDigitavelDealBillet.failure('Falha ao obter boleto.'));
  }
}

export default all([
  takeLatest(getAgreementDebt.request, getAgreementDebtSaga),
  takeLatest(getAgreementPortionDebt.request, getAgreementPortionDebtSaga),
  takeEvery(getBilletDeal.request, getBilletDealSaga),
  takeEvery(
    getLinhaDigitavelDealBillet.request,
    getLinhaDigitavelDealBilletSaga
  ),
]);
